import React, { useEffect, useState } from 'react';
import './StaticPage.css';
import './Anwendungsfaelle.css';

const Anwendungsfaelle = ({ onBack }) => {
    const [phase, setPhase] = useState(0);

    const steps = [
        'Antragstellung mit Darlehensverträgen von OneBank an RichBank',
        'Prüfung der Darlehen innerhalb der RichBank',
        'Refinanzierungsvertrag zwischen OneBank und RichBank',
        'Eintragung der Immobilien als Sicherheiten in das RefiReg der OneBank',
    ];

    useEffect(() => {
        const phaseDurations = [5200, 5200, 5600, 5000, 1400];
        const timer = setTimeout(() => {
            setPhase((prevPhase) => (prevPhase + 1) % (steps.length + 1));
        }, phaseDurations[phase]);

        return () => clearTimeout(timer);
    }, [phase, steps.length]);

    const currentStep = phase <= 3 ? phase : null;
    const isStepVisible = (stepIndex) => phase >= stepIndex && phase <= 3;
    const isCheckVisible = phase >= 1 && phase <= 3;

    return (
        <div className="static-page">
            <div className="static-content">
                <div className="static-header">
                    <img
                        src={`${process.env.PUBLIC_URL}/main.png`}
                        alt="SRR Logo"
                        className="static-logo"
                    />
                </div>

                <div className="static-text-container anwendungsfaelle-text">
                    <h1>Anwendungsfälle</h1>
                    <p>
                        Die Grafik zeigt den typischen Refinanzierungsprozess. Bank OneBank strebt eine Refinazierung
                        durch eine Pfandbriefbank RichBank an.
                    </p>

                    <div className="usecase-animation-container">
                        <div className="usecase-step-indicator">
                            {currentStep !== null ? (
                                <>Aktueller Schritt: <strong>{currentStep + 1}/4</strong> - {steps[currentStep]}</>
                            ) : (
                                <>Prozess wird neu gestartet...</>
                            )}
                        </div>
                        <svg viewBox="0 0 980 420" className="usecase-animation-svg" aria-label="Refinanzierungsprozess Animation">
                            <defs>
                                <marker
                                    id="usecase-arrow"
                                    markerWidth="10"
                                    markerHeight="8"
                                    refX="9"
                                    refY="4"
                                    orient="auto"
                                >
                                    <path d="M1,1 L9,4 L1,7" fill="none" stroke="#d9e6f2" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                                </marker>
                                <marker
                                    id="usecase-arrow-start"
                                    markerWidth="10"
                                    markerHeight="8"
                                    refX="9"
                                    refY="4"
                                    orient="auto-start-reverse"
                                >
                                    <path d="M1,1 L9,4 L1,7" fill="none" stroke="#d9e6f2" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                                </marker>
                            </defs>

                            <g className={`usecase-bank-house one-bank ${(currentStep === 0 || currentStep === 3) ? 'is-active' : ''}`}>
                                <polygon points="80,120 210,62 340,120" />
                                <rect x="90" y="120" width="240" height="190" rx="14" />
                                <text x="210" y="355" textAnchor="middle" className="usecase-bank-label">OneBank</text>

                                <g className="usecase-register">
                                    <rect x="118" y="208" width="62" height="82" rx="8" />
                                    <image
                                        href={`${process.env.PUBLIC_URL}/logo192-white.png`}
                                        x="126"
                                        y="216"
                                        width="46"
                                        height="46"
                                        preserveAspectRatio="xMidYMid meet"
                                    />
                                    <text x="149" y="281" textAnchor="middle">RefiReg</text>
                                </g>

                                <g className="usecase-banker">
                                    <circle cx="270" cy="250" r="14" />
                                    <path d="M254 278 Q270 258 286 278" />
                                </g>
                            </g>

                            <g className={`usecase-bank-house rich-bank ${(currentStep === 1 || currentStep === 2) ? 'is-active' : ''}`}>
                                <polygon points="640,120 770,62 900,120" />
                                <rect x="650" y="120" width="240" height="190" rx="14" />
                                <text x="770" y="355" textAnchor="middle" className="usecase-bank-label">RichBank</text>

                                <g className="usecase-banker">
                                    <circle cx="710" cy="250" r="14" />
                                    <path d="M694 278 Q710 258 726 278" />
                                </g>
                                <g className={`usecase-check ${isCheckVisible ? 'is-verified' : ''}`}>
                                    <path d="M755 248 L767 260 L787 236" />
                                </g>
                            </g>

                            <g className={`usecase-flow-step ${isStepVisible(0) ? 'is-visible' : ''}`}>
                                <path id="usecase-path-s1" d="M292 242 C390 154 610 154 688 242" className="usecase-flow segment-a" markerEnd="url(#usecase-arrow)" />
                                <text x="490" y="140" textAnchor="middle" className="usecase-flow-label">Antrag</text>

                                {currentStep === 0 && (
                                    <g className="usecase-packet">
                                        <circle cx="0" cy="0" r="5" />
                                        <animateMotion dur="3.1s" repeatCount="indefinite" path="M292 242 C390 154 610 154 688 242" />
                                    </g>
                                )}
                            </g>

                            <g className={`usecase-flow-step ${isStepVisible(1) ? 'is-visible' : ''}`}>
                                <path d="M736 250 C736 210 804 210 804 250 C804 290 736 290 736 250" className="usecase-flow segment-a" />
                                <text x="770" y="182" textAnchor="middle" className="usecase-flow-label">Pruefung</text>

                                {currentStep === 1 && (
                                    <g className="usecase-packet">
                                        <circle cx="0" cy="0" r="5" />
                                        <animateMotion dur="2.5s" repeatCount="indefinite" path="M736 250 C736 210 804 210 804 250 C804 290 736 290 736 250" />
                                    </g>
                                )}
                            </g>

                            <g className={`usecase-flow-step ${isStepVisible(2) ? 'is-visible' : ''}`}>
                                <path d="M688 258 C610 346 390 346 292 258" className="usecase-flow segment-a" markerEnd="url(#usecase-arrow)" markerStart="url(#usecase-arrow-start)" />
                                <text x="490" y="372" textAnchor="middle" className="usecase-flow-label">Vertrag</text>

                                {currentStep === 2 && (
                                    <g className="usecase-packet">
                                        <circle cx="0" cy="0" r="5" />
                                        <animateMotion
                                            dur="3.3s"
                                            repeatCount="indefinite"
                                            path="M292 258 C390 346 610 346 688 258"
                                            keyPoints="0;1;0"
                                            keyTimes="0;0.5;1"
                                            calcMode="linear"
                                        />
                                    </g>
                                )}
                            </g>

                            <g className={`usecase-flow-step ${isStepVisible(3) ? 'is-visible' : ''}`}>
                                <path d="M248 250 C230 220 210 214 188 249" className="usecase-flow segment-a" markerEnd="url(#usecase-arrow)" />
                                <text x="218" y="178" textAnchor="middle" className="usecase-flow-label">
                                    Eintragung
                                </text>

                                {currentStep === 3 && (
                                    <g className="usecase-packet">
                                        <circle cx="0" cy="0" r="5" />
                                        <animateMotion dur="2.5s" repeatCount="indefinite" path="M248 250 C230 220 210 214 188 249" />
                                    </g>
                                )}
                            </g>
                        </svg>
                    </div>

                    <div className="process-description">
                        <div className={`description-step ${currentStep === 0 ? 'highlight' : ''}`}>
                            1. <strong>Antragstellung:</strong> OneBank beantragt bei RichBank die Refinanzierung und übermittelt Darlehensverträge.
                        </div>
                        <div className={`description-step ${currentStep === 1 ? 'highlight' : ''}`}>
                            2. <strong>Pruefung in RichBank:</strong> Darlehen werden geprüft und bewertet.
                        </div>
                        <div className={`description-step ${currentStep === 2 ? 'highlight' : ''}`}>
                            3. <strong>Vertragabschluss:</strong> Refinanzierungsvertrag kommt zustande.
                        </div>
                        <div className={`description-step ${currentStep === 3 ? 'highlight' : ''}`}>
                            4. <strong>Eintragung ins Register:</strong> OneBank erfasst Immobilien als Sicherheiten im eigenen Refinanzierungsregister.
                        </div>
                    </div>
                </div>

                <button
                    className="static-back-link"
                    onClick={onBack}
                >
                    Zurück
                </button>
            </div>
        </div>
    );
};

export default Anwendungsfaelle;
